import { Check, Minus } from "lucide-react";
import { KUNDLI_COMPARISON } from "@/data/constants";

const GOLD = "#B89047";
const CHARCOAL = "#1A1A1A";
const OFF_WHITE = "#FDFCF8";
const BORDER = "#E5E0D8";

function CellValue({ value }) {
  if (value === true) return <Check size={15} color={GOLD} strokeWidth={2.5} />;
  if (value === false) return <Minus size={14} color="#CCC" />;
  return <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.8rem", color: "#4A4A4A", lineHeight: 1.4 }}>{value}</span>;
}

const thBase = { textAlign: "center", padding: "20px 16px", backgroundColor: "#F5F3EB", verticalAlign: "bottom" };

export default function KundliComparison() {
  return (
    <div data-testid="kundli-comparison" style={{ overflowX: "auto", border: `1px solid ${BORDER}` }}>
      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "640px" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", padding: "20px 24px", backgroundColor: "#F5F3EB", fontFamily: "'Outfit', sans-serif", fontSize: "0.62rem", letterSpacing: "0.18em", textTransform: "uppercase", color: "#8A8A8A", fontWeight: 600, minWidth: "200px", verticalAlign: "bottom", borderBottom: `2px solid ${BORDER}` }}>
              Feature
            </th>
            <th style={{ ...thBase, borderBottom: `2px solid ${BORDER}`, minWidth: "130px" }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.05rem", fontWeight: 500, color: CHARCOAL }}>Gold Kundli</p>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.85rem", fontWeight: 700, color: GOLD, marginTop: "4px" }}>₹3,100</p>
            </th>
            <th style={{ ...thBase, backgroundColor: "#FFFDF5", borderBottom: `2px solid ${GOLD}`, minWidth: "130px", position: "relative" }}>
              <span style={{ position: "absolute", top: "0", left: "50%", transform: "translateX(-50%)", backgroundColor: GOLD, color: CHARCOAL, padding: "3px 12px", fontFamily: "'Outfit', sans-serif", fontSize: "0.5rem", letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: 700, whiteSpace: "nowrap" }}>
                Most Detailed
              </span>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.05rem", fontWeight: 500, color: CHARCOAL, marginTop: "10px" }}>Premium Kundli</p>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.85rem", fontWeight: 700, color: GOLD, marginTop: "4px" }}>₹11,000</p>
            </th>
            <th style={{ ...thBase, borderBottom: `2px solid ${BORDER}`, minWidth: "130px" }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.05rem", fontWeight: 500, color: CHARCOAL }}>Yearly Astrology</p>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "0.85rem", fontWeight: 700, color: GOLD, marginTop: "4px" }}>₹25,000<span style={{ fontSize: "0.68rem", fontWeight: 400, color: "#8A8A8A" }}> / year</span></p>
            </th>
          </tr>
        </thead>
        <tbody>
          {KUNDLI_COMPARISON.map((row, i) => (
            <tr key={i} style={{ backgroundColor: i % 2 === 0 ? OFF_WHITE : "#FAF8F2" }}>
              <td style={{ padding: "14px 24px", borderBottom: `1px solid ${BORDER}`, fontFamily: "'Outfit', sans-serif", fontSize: "0.84rem", color: CHARCOAL, fontWeight: 500 }}>
                {row.feature}
              </td>
              <td style={{ textAlign: "center", padding: "14px 16px", borderBottom: `1px solid ${BORDER}` }}>
                <CellValue value={row.gold} />
              </td>
              <td style={{ textAlign: "center", padding: "14px 16px", borderBottom: `1px solid ${BORDER}`, backgroundColor: "rgba(184,144,71,0.04)" }}>
                <CellValue value={row.premium} />
              </td>
              <td style={{ textAlign: "center", padding: "14px 16px", borderBottom: `1px solid ${BORDER}` }}>
                <CellValue value={row.yearly} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
